import { t } from 'i18next';
import moment from 'moment';
// import { LanguageType } from 'src/types/language.type';

// The provided function, formatDate, formats a given date into a specific string format: DD/MM/YYYY - HH:mm
export const formatDate = (date: Date | string | number | undefined): string => {
  if (!date) return '';
  const d = new Date(date);

  let month = `${d.getMonth() + 1}`;
  let day = `${d.getDate()}`;
  const year = d.getFullYear();

  if (month.length < 2) month = `0${month}`;
  if (day.length < 2) day = `0${day}`;

  let hours = d.getHours().toString();
  let minutes = d.getMinutes().toString();

  if (hours.length < 2) hours = `0${hours}`;
  if (minutes.length < 2) minutes = `0${minutes}`;

  return `${day}/${month}/${year} - ${hours}:${minutes}`;
};

/*
The function convertTimeToCalendarTexts converts a given time (if provided) into a string representation, 
either as a predefined "calendar text" (like sameDay or lastDay) or as a formatted date string in the DD/MM/YYYY format. 
*/
export const convertTimeToCalendarTexts = (time?: string) => {
  const calendarKeys: {
    [key in string]: string;
  } = {
    sameDay: '[sameDay]',
    lastDay: '[lastDay]',
  };

  const momentCalendarKey = moment(time).calendar(calendarKeys);

  if (momentCalendarKey === 'lastDay' || momentCalendarKey === 'sameDay') {
    return t(`momentCalendar.${momentCalendarKey}`);
  }

  return moment(time).format('DD/MM/YYYY');
};

/*
The compareDates function compares two date-time strings (first and second) formatted as DD/MM/YYYY HH:mm 
and determines their chronological order
*/
export const compareDates = (first: string, second: string) => {
  if (!first) {
    return -1;
  }
  if (!second) {
    return 1;
  }

  return moment(first, 'DD/MM/YYYY HH:mm').diff(moment(second, 'DD/MM/YYYY HH:mm'));
};

// nsearch de kullanılan time converter function...
export function getDateString(timestamp: number | undefined) {
  if (!timestamp) {
    return;
  }
  const date = new Date(timestamp);

  const year = date.getFullYear();
  const month = `0${date.getMonth() + 1}`.slice(-2);
  const day = `0${date.getDate()}`.slice(-2);
  const hours = `0${date.getHours()}`.slice(-2);
  const minutes = `0${date.getMinutes()}`.slice(-2);
  const seconds = `0${date.getSeconds()}`.slice(-2);

  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}
